import Modal from 'components/commons/modal/Modal2';
import React from 'react';
import { isIosApp } from '../utils/userStatus';

export const WhatIsOtherModal = ({
  hide,
  isShow,
}: {
  isShow: boolean;
  hide: () => void;
}): React.ReactElement => {
  return (
    <>
      <Modal {...{ isShow: isShow, close: hide }}>
        <div className={`ui-border-b flex flex-col pt-4`}>
          <div className="flex flex-row pb-4 px-4">
            <div className={`text-bluegray-700 font-bold text-base`}>
              その他に含まれる資産
            </div>
            <div
              className={`icon-close text-bluegray-400 ml-auto text-lg cursor-pointer`}
              onClick={hide}></div>
          </div>
          <div className={`px-4 pb-2 text-sm`}>
            {!isIosApp() && <div>・Moneytreeに連携しているすべての資産</div>}
            <div>・現金、手入力資産</div>
            <div>・データ取得中の銘柄情報</div>
            <div>・一部のアクティブファンド等、分類ができない投資信託</div>
          </div>
          <button
            onClick={hide}
            className={`bg-white p-4 px-8 text-bluegray-500 text-sm flex justify-center items-center`}>
            閉じる
          </button>
        </div>
      </Modal>
    </>
  );
};
